export const indexPermissionGroupsPath: string = "/permissionGroups";
export const newPermissionGroupsPath: string = "/permissionGroups/new";
export const editPermissionGroupsPath: string = "/permissionGroups/:id/edit";
export const editPermissionGroupsPathCreator = (id: number|string): string => `/permissionGroups/${id}/edit`